var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscordIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_17594)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_334_17594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_334_17594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.48657 16.25C10.4866 18.75 13.4866 18.75 18.4866 16.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4866 17.75L16.4866 19.75C16.4866 19.75 20.6576 18.422 21.9866 16.25C21.9866 15.25 22.5166 8.103 18.9866 5.75C17.7411 5.04136 16.3909 4.53505 14.9866 4.25L13.9866 6.25H11.9866",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51459 17.75L7.51459 19.75C7.51459 19.75 3.34359 18.422 2.01459 16.25C2.01459 15.25 1.48459 8.103 5.01459 5.75C6.26009 5.04136 7.61025 4.53505 9.01459 4.25L10.0146 6.25H12.0146",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48657 14.25C7.65857 14.25 6.98657 13.35 6.98657 12.25C6.98657 11.15 7.65857 10.25 8.48657 10.25C9.31457 10.25 9.98657 11.15 9.98657 12.25C9.98657 13.35 9.31457 14.25 8.48657 14.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4866 14.25C14.6586 14.25 13.9866 13.35 13.9866 12.25C13.9866 11.15 14.6586 10.25 15.4866 10.25C16.3146 10.25 16.9866 11.15 16.9866 12.25C16.9866 13.35 16.3146 14.25 15.4866 14.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_17594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordIcon2);
export default __webpack_public_path__ + "static/media/discord-icon-2.e396ec5a4f50746a472ee8a20241c946.svg";
export { ForwardRef as ReactComponent };